import React from 'react';

export default function ColoredBorders() {
  return (
    <div className="flex">
      <div className="w-1/4 h-2 bg-rf-blue" />
      <div className="w-1/4 h-2 bg-rf-yellow" />
      <div className="w-1/4 h-2 bg-rf-navy" />
      <div className="w-1/4 h-2 bg-rf-red" />
    </div>
  );
}
